<section class="card-bg relative overflow-hidden rounded-2xl dark:bg-surface-1/60" [class.pb-24]="selectedIds().length > 0">
  <div class="space-y-6 px-5 py-6 md:px-8 md:py-8">
    <app-unpaid-partner-overview-cards
      [data]="overview()"
      [loading]="loading()"
      [calculating]="overviewCalculating()"
      [payAllLabel]="payAllButtonLabel()"
      [payAllDisabled]="paying() || payableCount() === 0 || selectedIds().length > 0"
      [payUrgentDisabled]="payUrgentDisabled()"
      [hideUrgentAmount]="isLendeeFilter()"
      [showUrgentAction]="showUrgentOverviewAction"
      [showAskPrismAi]="false"
      (payAllToBusiness)="payAllToBusiness()"
      (payUrgent)="payAllUrgentVisible()"
    >
      <div overview-header-actions class="flex flex-wrap items-center justify-end gap-3">
        <app-unpaid-payments-is-dummy-toggle (dummyChange)="onIsDummyToggle($event)"></app-unpaid-payments-is-dummy-toggle>
      <div class="w-[250px] min-w-[200px]">
        <app-dropdown
          [options]="countryFilterOptions"
          [selectedValue]="countryIdDropdownValue()"
          selectionMode="single"
          selectionStyle="none"
          type="selection"
          placeholder="Country"
          variant="outline"
          size="md"
          [maxHeight]="'240px'"
          [fullWidth]="true"
          [showTooltip]="false"
          chevronIcon="chevron-down"
          [menuFixed]="false"
          [wrapLabels]="false"
          menuClass="!z-[200] shadow-xl"
          (selectionChange)="onCountryDropdownChange($event)"
        ></app-dropdown>
      </div>
      </div>
    </app-unpaid-partner-overview-cards>

    <section
      class="relative z-10 mt-4 rounded-[14px] bg-white p-4 shadow-[0_1px_4px_0_rgba(0,0,0,0.1)] dark:border-surface-3 dark:bg-surface-1"
    >
      @if (isLendeeFilter()) {
      <div class="flex flex-nowrap items-end gap-2 pb-0.5">
        <div class="w-[9.5rem] shrink-0">
          <label class="mb-1.5 block text-[12px] font-medium text-[#7d7d93] dark:text-ink-muted">Start date</label>
          <div class="relative z-[31]">
            <app-selection
              mode="date-picker"
              [enableYearMonthPicker]="true"
              [disableFutureDates]="true"
              [minDate]="defaultStartDate"
              [ngModel]="startDateDraft()"
              (ngModelChange)="startDateDraft.set($event)"
              [maxDate]="startDateMax()"
              datePlaceholder="Start date"
            ></app-selection>
          </div>
        </div>

        <div class="w-[9.5rem] shrink-0">
          <label class="mb-1.5 block text-[12px] font-medium text-[#7d7d93] dark:text-ink-muted">End date</label>
          <div class="relative z-[30]">
            <app-selection
              mode="date-picker"
              [enableYearMonthPicker]="true"
              [disableFutureDates]="true"
              [ngModel]="endDateDraft()"
              (ngModelChange)="endDateDraft.set($event)"
              [minDate]="startDateDraft()"
              [maxDate]="endDateMax()"
              datePlaceholder="End date"
            ></app-selection>
          </div>
        </div>

        <div class="w-[12rem] min-w-0 shrink-0">
          <label class="mb-1.5 block text-[12px] font-medium text-[#7d7d93] dark:text-ink-muted">Filter by</label>
          <div class="relative z-[30] min-w-0 overflow-visible">
            <app-dropdown
              [options]="filterDropdownOptions"
              [selectedValue]="fmFilterDropdownValue()"
              selectionMode="single"
              placeholder="Filter by"
              variant="themeBase"
              customHeight="'38px'"
              size="sm"
              [rounded]="'md'"
              [fullWidth]="true"
              [showTooltip]="true"
              textClass="truncate min-w-0"
              triggerClass="!overflow-hidden"
              chevronIcon="chevron-down"
              [tooltipFixedStrategy]="true"
              [menuFixed]="false"
              menuClass="!z-[200] shadow-xl !min-w-[220px] !max-w-[280px]"
              (selectionChange)="onFilterDropdownChange($event)"
            ></app-dropdown>
          </div>
        </div>

        <div class="w-[9rem] shrink-0">
          <label class="mb-1.5 block text-[12px] font-medium text-[#7d7d93] dark:text-ink-muted">Beneficiary Type</label>
          <div class="relative z-[29]">
            <app-dropdown
              [options]="lendeeShareTypeOptions"
              [selectedValue]="'' + lendeeShareTypeDraft()"
              selectionMode="single"
              placeholder="Beneficiary Type"
              variant="themeBase"
              customHeight="'38px'"
              size="sm"
              [rounded]="'md'"
              [fullWidth]="true"
              [showTooltip]="false"
              chevronIcon="chevron-down"
              [tooltipFixedStrategy]="true"
              [menuFixed]="false"
              menuClass="!z-[200] shadow-xl"
              (selectionChange)="onLendeeShareTypeChange($event)"
            ></app-dropdown>
          </div>
        </div>

        <div class="w-[9rem] shrink-0">
          <label class="mb-1.5 block text-[12px] font-medium text-[#7d7d93] dark:text-ink-muted">Payment Status</label>
          <div class="relative z-[28]">
            <app-dropdown
              [options]="lendeePaymentStatusOptions"
              [selectedValue]="'' + lendeePaymentStatusDraft()"
              selectionMode="single"
              placeholder="Payment Status"
              variant="themeBase"
              customHeight="'38px'"
              size="sm"
              [rounded]="'md'"
              [fullWidth]="true"
              [showTooltip]="false"
              chevronIcon="chevron-down"
              [tooltipFixedStrategy]="true"
              [menuFixed]="false"
              menuClass="!z-[200] shadow-xl"
              (selectionChange)="onLendeePaymentStatusChange($event)"
            ></app-dropdown>
          </div>
        </div>

        <div class="min-w-[10.5rem] max-w-[12rem] shrink-0 flex-[1_1_10.5rem]">
          <label class="mb-1.5 block text-[12px] font-medium text-[#7d7d93] dark:text-ink-muted">Search</label>
          <div class="flex h-[38px] overflow-hidden rounded-[10px] border border-[#d1d5dc] bg-white dark:border-surface-3 dark:bg-surface-0">
            <div class="relative min-w-0 flex-1">
              <input
                class="h-full w-full border-0 bg-transparent pl-9 pr-2 text-[14px] text-[#38385b] outline-none placeholder:text-[#7d7d93] focus:ring-0 dark:text-ink-soft dark:placeholder:text-ink-subtle"
                [ngModel]="searchDraft()"
                (ngModelChange)="searchDraft.set($event)"
                (keyup.enter)="applyFilters()"
                placeholder="Search..."
              />
              <app-icon-v2
                name="search"
                size="16"
                class="pointer-events-none absolute inset-y-0 left-2.5 my-auto text-[#7d7d93] dark:text-ink-muted"
              ></app-icon-v2>
            </div>
            @if (searchDraft().trim()) {
              <button
                type="button"
                class="shrink-0 border-l border-[#d1d5dc] px-2.5 text-[12px] font-semibold text-[#38385b] transition hover:bg-[#f8f8f8] dark:border-surface-3 dark:text-ink-soft dark:hover:bg-surface-3"
                (click)="clearSearch()"
              >
                Clear
              </button>
            }
          </div>
        </div>

        <div class="flex h-[38px] shrink-0 items-center self-end pb-0.5">
          <app-toggle
            [checked]="urgentOnlyDraft()"
            label="Urgent only"
            labelPosition="after"
            size="sm"
            className="shrink-0 whitespace-nowrap"
            (toggleChange)="setUrgentOnly($event)"
          ></app-toggle>
        </div>

        <div class="ml-auto flex shrink-0 items-end gap-2 self-end">
          <app-button variant="primary" size="md" [maxHeight]="'38px'" (click)="applyFilters()">Apply</app-button>
          <button
            type="button"
            class="inline-flex h-[38px] items-center gap-1.5 rounded-[10px] border border-[#d1d5dc] bg-white px-4 text-[14px] font-semibold text-[#38385b] transition hover:bg-[#f8f8f8] dark:border-surface-3 dark:bg-surface-0 dark:text-ink-soft dark:hover:bg-surface-3"
            (click)="resetFilters()"
          >
            Reset
          </button>
        </div>
      </div>
      } @else {
      <div class="flex flex-nowrap items-end gap-2 pb-0.5">
        <div class="min-w-[10.5rem] max-w-[12rem] shrink-0 flex-[1_1_10.5rem]">
          <label class="mb-1.5 block text-[12px] font-medium text-[#7d7d93] dark:text-ink-muted">Search</label>
          <div class="flex h-[38px] overflow-hidden rounded-[10px] border border-[#d1d5dc] bg-white dark:border-surface-3 dark:bg-surface-0">
            <div class="relative min-w-0 flex-1">
              <input
                class="h-full w-full border-0 bg-transparent pl-9 pr-2 text-[14px] text-[#38385b] outline-none placeholder:text-[#7d7d93] focus:ring-0 dark:text-ink-soft dark:placeholder:text-ink-subtle"
                [ngModel]="search()"
                (ngModelChange)="search.set($event)"
                (keyup.enter)="applyFilters()"
                placeholder="Search..."
              />
              <app-icon-v2
                name="search"
                size="16"
                class="pointer-events-none absolute inset-y-0 left-2.5 my-auto text-[#7d7d93] dark:text-ink-muted"
              ></app-icon-v2>
            </div>
            @if (searchApplied()) {
              <button
                type="button"
                class="shrink-0 border-l border-[#d1d5dc] px-2.5 text-[12px] font-semibold text-[#38385b] transition hover:bg-[#f8f8f8] dark:border-surface-3 dark:text-ink-soft dark:hover:bg-surface-3"
                (click)="clearSearch()"
              >
                Clear
              </button>
            }
          </div>
        </div>

        @if (showVipFilter()) {
          <div class="w-[7.25rem] shrink-0">
            <label class="mb-1.5 block text-[12px] font-medium text-[#7d7d93] dark:text-ink-muted">Type</label>
            <div class="relative z-[28]">
              <app-dropdown
                [options]="vipDropdownOptions"
                [selectedValue]="vipTypeDropdownValue()"
                selectionMode="single"
                placeholder="Type"
                variant="themeBase"
                customHeight="'38px'"
                size="sm"
                [rounded]="'md'"
                [fullWidth]="true"
                [showTooltip]="false"
                chevronIcon="chevron-down"
                [tooltipFixedStrategy]="true"
                [menuFixed]="false"
                menuClass="!z-[200] shadow-xl"
                (selectionChange)="onVipDropdownChange($event)"
              ></app-dropdown>
            </div>
          </div>
        }

        <div class="w-[12rem] min-w-0 shrink-0">
          <label class="mb-1.5 block text-[12px] font-medium text-[#7d7d93] dark:text-ink-muted">Filter by</label>
          <div class="relative z-[30] min-w-0 overflow-visible">
            <app-dropdown
              [options]="filterDropdownOptions"
              [selectedValue]="fmFilterDropdownValue()"
              selectionMode="single"
              placeholder="Filter by"
              variant="themeBase"
              customHeight="'38px'"
              size="sm"
              [rounded]="'md'"
              [fullWidth]="true"
              [showTooltip]="true"
              textClass="truncate min-w-0"
              triggerClass="!overflow-hidden"
              chevronIcon="chevron-down"
              [tooltipFixedStrategy]="true"
              [menuFixed]="false"
              menuClass="!z-[200] shadow-xl !min-w-[220px] !max-w-[280px]"
              (selectionChange)="onFilterDropdownChange($event)"
            ></app-dropdown>
          </div>
        </div>

        @if (showPartnerStatusFilter()) {
          <div class="w-[9.5rem] shrink-0">
            <label class="mb-1.5 block text-[12px] font-medium text-[#7d7d93] dark:text-ink-muted">Partner status</label>
            <div class="relative z-[27]">
              <app-dropdown
                [options]="partnerStatusDropdownOptions"
                [selectedValue]="fmPartnerStatus()"
                selectionMode="single"
                placeholder="Partner status"
                variant="themeBase"
                customHeight="'38px'"
                size="sm"
                [rounded]="'md'"
                [fullWidth]="true"
                [showTooltip]="false"
                chevronIcon="chevron-down"
                [tooltipFixedStrategy]="true"
                [menuFixed]="false"
                menuClass="!z-[200] shadow-xl"
                (selectionChange)="onPartnerStatusDropdownChange($event)"
              ></app-dropdown>
            </div>
          </div>
        }

        @if (showStatusFilter()) {
          <div class="w-[8.5rem] shrink-0">
            <label class="mb-1.5 block text-[12px] font-medium text-[#7d7d93] dark:text-ink-muted">{{ statusFilterLabel }}</label>
            <div class="relative z-[29]">
              <app-dropdown
                [options]="statusDropdownOptions"
                [selectedValue]="fmStatusFilter()"
                selectionMode="single"
                [placeholder]="statusFilterLabel"
                variant="themeBase"
                customHeight="'38px'"
                size="sm"
                [rounded]="'md'"
                [fullWidth]="true"
                [showTooltip]="false"
                chevronIcon="chevron-down"
                [tooltipFixedStrategy]="true"
                [menuFixed]="false"
                menuClass="!z-[200] shadow-xl min-w-[200px]"
                (selectionChange)="onStatusDropdownChange($event)"
              ></app-dropdown>
            </div>
          </div>
        }

        @if (showOrpFilterControl()) {
          <div class="w-[7.25rem] shrink-0">
            <label class="mb-1.5 block text-[12px] font-medium text-[#7d7d93] dark:text-ink-muted">ORP filter</label>
            <div class="relative z-[26]">
              <app-dropdown
                [options]="orpDropdownOptions"
                [selectedValue]="orpFilterDropdownValue()"
                selectionMode="single"
                placeholder="ORP"
                variant="themeBase"
                customHeight="'38px'"
                size="sm"
                [rounded]="'md'"
                [fullWidth]="true"
                [showTooltip]="false"
                chevronIcon="chevron-down"
                [disabled]="orpFilterDisabled()"
                [tooltipFixedStrategy]="true"
                [menuFixed]="false"
                menuClass="!z-[200] shadow-xl"
                (selectionChange)="onOrpDropdownChange($event)"
              ></app-dropdown>
            </div>
          </div>
        }

        @if (showInstantClaimFilter()) {
          <div class="w-[7.75rem] shrink-0">
            <label class="mb-1.5 block text-[12px] font-medium text-[#7d7d93] dark:text-ink-muted">Instant claim</label>
            <div class="relative z-[25]">
              <app-dropdown
                [options]="instantClaimDropdownOptions"
                [selectedValue]="instantClaimDropdownValue()"
                selectionMode="single"
                placeholder="Instant claim"
                variant="themeBase"
                customHeight="'38px'"
                size="sm"
                [rounded]="'md'"
                [fullWidth]="true"
                [showTooltip]="false"
                chevronIcon="chevron-down"
                [disabled]="instantClaimFilterDisabled()"
                [tooltipFixedStrategy]="true"
                [menuFixed]="false"
                menuClass="!z-[200] shadow-xl"
                (selectionChange)="onInstantClaimDropdownChange($event)"
              ></app-dropdown>
            </div>
          </div>
        }

        @if (fmFilter() === 13) {
          <div class="w-[8.5rem] shrink-0">
            <label class="mb-1.5 block text-[12px] font-medium text-[#7d7d93] dark:text-ink-muted">Reward type</label>
            <div class="relative z-[24]">
              <app-dropdown
                [options]="challengeDropdownOptions"
                [selectedValue]="challengeType()"
                selectionMode="single"
                placeholder="Reward type"
                variant="themeBase"
                customHeight="'38px'"
                size="sm"
                [rounded]="'md'"
                [fullWidth]="true"
                [showTooltip]="false"
                chevronIcon="chevron-down"
                [tooltipFixedStrategy]="true"
                [menuFixed]="false"
                menuClass="!z-[200] shadow-xl"
                (selectionChange)="onChallengeDropdownChange($event)"
              ></app-dropdown>
            </div>
          </div>
        }

        <div class="flex h-[38px] shrink-0 items-center self-end pb-0.5">
          <app-toggle
            [checked]="urgentOnly()"
            label="Urgent only"
            labelPosition="after"
            size="sm"
            className="shrink-0 whitespace-nowrap"
            (toggleChange)="setUrgentOnly($event)"
          ></app-toggle>
        </div>

        <div class="ml-auto flex shrink-0 items-end gap-2 self-end">
          <div class="relative z-[30]">
            <app-dropdown
              [options]="exportDropdownOptions"
              selectionMode="single"
              selectionStyle="none"
              variant="themeBase"
              [fullWidth]="false"
              className="!w-auto"
              [showTooltip]="false"
              [tooltipFixedStrategy]="true"
              [menuFixed]="false"
              menuClass="!z-[200] min-w-[160px] shadow-xl"
              (selectionChange)="onExportDropdownChange($event)"
            >
              <span
                appDropdownTrigger
                tabindex="0"
                role="button"
                class="inline-flex h-[38px] cursor-pointer items-center gap-2 rounded-[8px] bg-[#f2f5f8] px-4 text-[13px] font-bold uppercase tracking-[0.04em] text-[#38385b] transition hover:bg-[#e8ecf1] dark:bg-surface-3 dark:text-ink-soft dark:hover:bg-surface-3"
                [class.pointer-events-none]="exporting() || !totalCount()"
                [class.opacity-60]="exporting() || !totalCount()"
              >
                <app-icon-v2 name="external-link" size="16" class="text-[#38385b] dark:text-ink-soft"></app-icon-v2>
                {{ exporting() ? 'Exporting...' : 'EXPORT' }}
              </span>
            </app-dropdown>
          </div>
          <app-button variant="primary" size="md" [maxHeight]="'38px'" (click)="applyFilters()">Apply</app-button>
          <button
            type="button"
            class="inline-flex h-[38px] items-center gap-1.5 rounded-[10px] border border-[#d1d5dc] bg-white px-4 text-[14px] font-semibold text-[#38385b] transition hover:bg-[#f8f8f8] dark:border-surface-3 dark:bg-surface-0 dark:text-ink-soft dark:hover:bg-surface-3"
            (click)="resetFilters()"
          >
            Reset
          </button>
        </div>
      </div>
      }
    </section>

    <div
      class="relative z-0 min-h-[400px] overflow-visible rounded-[14px] bg-white shadow-[0_1px_4px_0_rgba(0,0,0,0.1)] dark:border-surface-3 dark:bg-surface-1"
    >
      @if (tableBusy()) {
        <div
          class="absolute inset-0 z-10 flex items-center justify-center overflow-hidden rounded-[14px] bg-white/60 backdrop-blur-sm dark:bg-surface-1/60"
        >
          <div class="flex flex-col items-center gap-4">
            <div class="h-10 w-10 animate-spin rounded-full border-4 border-purple-600 border-t-transparent"></div>
            <p class="animate-pulse font-bold text-slate-600 dark:text-slate-400">{{ tableBusyMessage() }}</p>
          </div>
        </div>
      }

      <div class="" [class.pointer-events-none]="tableBusy()" [class.opacity-50]="tableBusy()">
        @if (!tableBusy() && !payments().length) {
        <div
          class="flex min-h-[280px] flex-col items-center justify-center px-4 py-12 text-center"
        >
          <svg width="138" height="81" viewBox="0 0 138 81" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path
              d="M129.789 70.1323H2.66082C1.95537 70.1315 1.27904 69.8553 0.780215 69.3643C0.281386 68.8733 0.000794248 68.2076 0 67.5132V2.61905C0.000819236 1.92468 0.281418 1.25899 0.780242 0.767996C1.27907 0.277004 1.95538 0.000806374 2.66082 0H129.789C130.494 0.000782547 131.171 0.276972 131.67 0.76797C132.168 1.25897 132.449 1.92467 132.45 2.61905V67.5132C132.449 68.2076 132.168 68.8733 131.67 69.3643C131.171 69.8553 130.494 70.1315 129.789 70.1323ZM2.66082 0.582011C2.11214 0.582616 1.5861 0.797426 1.19812 1.17931C0.810146 1.5612 0.591909 2.07898 0.591294 2.61905V67.5132C0.591934 68.0533 0.810183 68.5711 1.19816 68.9529C1.58613 69.3348 2.11215 69.5496 2.66082 69.5503H129.789C130.338 69.5496 130.864 69.3348 131.252 68.9529C131.64 68.571 131.858 68.0533 131.859 67.5132V2.61905C131.858 2.07899 131.64 1.56123 131.252 1.17934C130.864 0.797463 130.338 0.582641 129.789 0.582011H2.66082Z"
              fill="#EAEAEA"
            />
            <path
              d="M110.3 43.9258C116.673 42.7288 122.804 46.9346 123.997 53.3135C124.591 56.491 123.844 59.6074 122.161 62.084L136.68 75.9404C137.724 76.9357 137.777 78.5832 136.802 79.6445C135.757 80.7811 133.97 80.7843 132.922 79.6533H132.921L119.35 64.9941C117.987 65.9865 116.388 66.6992 114.623 67.0303C108.249 68.2274 102.118 64.0217 100.926 57.6426C99.731 51.2611 103.927 45.1229 110.3 43.9258ZM120.618 53.9512C119.775 49.4382 115.439 46.4668 110.935 47.3105C106.43 48.1545 103.462 52.497 104.305 57.0107C105.148 61.5236 109.483 64.4942 113.988 63.6504C118.493 62.8065 121.461 58.4648 120.618 53.9512Z"
              fill="#AD46FF"
              stroke="white"
            />
          </svg>
          <h3 class="mb-2 text-[22px] font-bold text-[#141437] dark:text-white">No Data Found</h3>
          <p class="text-[16px] text-[#7d7d93] dark:text-ink-muted">No matching records found. Please change your search</p>
        </div>
        }

        @if (isLendeeFilter() && payments().length) {
        <div class="min-w-0 overflow-x-auto">
        <app-paginated-table
          [headers]="lendeeTableHeaders"
          [tableData]="payments()"
          [isCheckboxShow]="false"
          [selection]="selectedRows()"
          [isRowSelectable]="canSelectRowBind"
          (selectionChange)="onSelectionChange($event)"
          [serverSide]="true"
          [totalItems]="totalCount()"
          [pageCount]="totalPages()"
          [currentPage]="page()"
          [pageSize]="pageSize"
          (pageChange)="goToPage($event)"
          [tableKey]="'credee-lendee'"
          tableClass="min-w-full"
          [tableWrapperClass]="'h-full rounded-2xl dark:bg-surface-1 bg-white'"
          containerClass="overflow-x-auto min-w-0"
          [cellTemplates]="{
            serialNo: lendeeSerialNoTemplate,
            payableAmount: lendeePayableAmountTemplate,
            shareType: lendeeShareTypeTemplate,
            lendeeStatus: lendeeStatusTemplate,
            contractDetails: lendeeContractDetailsTemplate,
            supporterDetails: lendeeSupporterDetailsTemplate,
            paymentDetails: lendeePaymentDetailsTemplate,
            businessInsights: lendeeBusinessInsightsTemplate,
            supporterInsights: lendeeSupporterInsightsTemplate,
            bankAdded: lendeeBankAddedTemplate,
            action: lendeeActionTemplate
          }"
        ></app-paginated-table>
        </div>
        }

        @if (!isLendeeFilter() && payments().length) {
        <div class="min-w-0 overflow-x-auto">
        <app-paginated-table
          [headers]="tableHeaders"
          [tableData]="payments()"
          [isCheckboxShow]="fmFilter() !== 2 && fmFilter() !== 7"
          [selection]="selectedRows()"
          [isRowSelectable]="canSelectRowBind"
          (selectionChange)="onSelectionChange($event)"
          [serverSide]="true"
          [totalItems]="totalCount()"
          [pageCount]="totalPages()"
          [currentPage]="page()"
          [pageSize]="pageSize"
          (pageChange)="goToPage($event)"
          [tableKey]="'credee-unpaid-' + fmFilter()"
          tableClass="min-w-max w-full"
          [tableWrapperClass]="'h-full rounded-2xl dark:bg-surface-1 bg-white'"
          containerClass="overflow-x-auto min-w-0"
          [cellTemplates]="{
            contractId: contractIdTemplate,
            businessOwner: businessOwnerTemplate,
            businessOwnerEmail: businessOwnerEmailTemplate,
            businessName: businessNameTemplate,
            offerType: offerTypeTemplate,
            rewardPrize: rewardPrizeTemplate,
            recurringAmount: recurringAmountTemplate,
            status: statusTemplate,
            orp: orpTemplate,
            instantClaim: instantClaimTemplate,
            lastContractDate: lastContractDateTemplate,
            paymentDate: paymentDateTemplate,
            partnerName: partnerNameTemplate,
            partnerEmail: partnerEmailTemplate,
            transferToBusiness: amountDisplayTemplate,
            payableAmount: amountDisplayTemplate,
            shareFromBusiness: shareFromBusinessTemplate,
            bankAdded: bankAddedTemplate,
            action: actionTemplate
          }"
        ></app-paginated-table>
        </div>
        }
      </div>
    </div>
  </div>
</section>

<ng-template #contractIdTemplate let-row>
  <span class="text-[14px] font-medium text-[#141437] dark:text-white">{{ getAccountCode(row) }}</span>
</ng-template>

<ng-template #businessOwnerTemplate let-row>
  <span class="text-[14px] text-[#141437] dark:text-white">{{ getBusinessOwnerName(row) }}</span>
</ng-template>

<ng-template #businessOwnerEmailTemplate let-row>
  <span class="text-[14px] text-[#7d7d93] dark:text-ink-muted">{{ getBusinessOwnerEmail(row) }}</span>
</ng-template>

<ng-template #businessNameTemplate let-row>
  <span class="text-[14px] text-[#141437] dark:text-white">{{ getBusinessName(row) }}</span>
</ng-template>

<ng-template #offerTypeTemplate let-row>
  <span class="text-[14px] text-[#141437] dark:text-white">{{ getOfferTypeLabel(row) }}</span>
</ng-template>

<ng-template #rewardPrizeTemplate let-row>
  <span class="text-[14px] text-[#141437] dark:text-white">{{ getRewardPrizeLabel(row) }}</span>
</ng-template>

<ng-template #recurringAmountTemplate let-row>
  <span class="text-[14px] font-semibold tabular-nums text-[#141437] dark:text-white">
    {{ getAmountSymbol(row) }}{{ getAmountCharged(row) | number : '1.2-2' }}
  </span>
</ng-template>

<ng-template #statusTemplate let-row>
  <span class="text-[14px] font-medium" [ngClass]="{
    'text-[#15b268]': getStatusTone(getStatusLabel(row)) === 'success',
    'text-[#f05050]': getStatusTone(getStatusLabel(row)) === 'danger',
    'text-[#ffa514]': getStatusTone(getStatusLabel(row)) === 'warning',
    'text-[#7d7d93] dark:text-ink-muted': getStatusTone(getStatusLabel(row)) === 'neutral'
  }">
    {{ getStatusLabel(row) }}
  </span>
</ng-template>

<ng-template #orpTemplate let-row>
  <span class="text-[14px] text-[#141437] dark:text-white">{{ row['is_orp'] == 1 ? 'Yes' : 'No' }}</span>
</ng-template>

<ng-template #instantClaimTemplate let-row>
  <span class="text-[14px] text-[#141437] dark:text-white">{{ row['is_orp_instant_claim'] == 1 ? 'Yes' : 'No' }}</span>
</ng-template>

<ng-template #lastContractDateTemplate let-row>
  <span class="text-[14px] text-[#141437] dark:text-white">{{ formatTableDate(row['last_contract_date']) }}</span>
</ng-template>

<ng-template #paymentDateTemplate let-row>
  <span class="text-[14px] text-[#141437] dark:text-white">{{ formatTableDate(row['unpaid_payment_date'] || row['date_added']) }}</span>
</ng-template>

<ng-template #partnerNameTemplate let-row>
  <span class="text-[14px] text-[#141437] dark:text-white">{{ getPartnerName(row) }}</span>
</ng-template>

<ng-template #partnerEmailTemplate let-row>
  <span class="text-[14px] text-[#7d7d93] dark:text-ink-muted">{{ getPartnerEmail(row) }}</span>
</ng-template>

<ng-template #shareFromBusinessTemplate let-row>
  <span class="text-[14px] text-[#141437] dark:text-white">{{ getShareFromBusinessLabel(row) }}</span>
</ng-template>

<ng-template #amountDisplayTemplate let-row>
  <div class="flex flex-col items-start gap-1">
    <span class="text-[14px] font-semibold tabular-nums text-[#141437] dark:text-white">
      {{ getAmountSymbol(row) }}{{ getRowAmountDisplay(row) | number : '1.2-2' }}
    </span>
    @if (isUrgent(row) || isVip(row)) {
      <div class="flex flex-wrap items-center justify-start gap-1">
        @if (isVip(row)) {
          <span
            class="inline-flex w-max items-center gap-1 rounded-full bg-[#fff9e8] px-2 py-0.5 text-[11px] font-semibold text-[#ffa514] dark:bg-[#4b3817] dark:text-[#ffd37a]"
          >
            <app-icon-v2 name="gem" size="10" customClass="text-[#ffa514]"></app-icon-v2>
            VIP
          </span>
        }
        @if (isUrgent(row)) {
          <span
            class="inline-flex w-max items-center gap-1 rounded-full bg-[#f4e5ff] px-2 py-0.5 text-[11px] font-medium text-[#ad46ff] dark:bg-purple-800 dark:text-white"
          >
            <app-icon-v2 name="zap" size="10" customClass="text-[#ad46ff] fill-current"></app-icon-v2>
            Urgent Payment
          </span>
        }
      </div>
    }
  </div>
</ng-template>

<ng-template #bankAddedTemplate let-row>
  <div class="text-[14px] text-[#141437] dark:text-white">
    {{ getBankAdded(row) }}
    @if (row['transfers_disabled'] != 1 && (fmFilter() === 5 || fmFilter() === 8 || fmFilter() === 14 || fmFilter() === 15)) {
      <span class="mt-1 block text-[12px] text-[#f05050] dark:text-[#ff9090]">
        (Transfer Disabled)
      </span>
    }
  </div>
</ng-template>

<ng-template #lendeeSerialNoTemplate let-row let-i="index">
  <span class="text-[14px] font-medium text-[#141437] dark:text-white">{{ offset() + i + 1 }}</span>
</ng-template>

<ng-template #lendeePayableAmountTemplate let-row>
  <div class="flex flex-col items-start gap-1">
    <span class="text-[14px] font-semibold tabular-nums text-[#141437] dark:text-white">
      ${{ getLendeePayableAmount(row) | number : '1.2-2' }}
    </span>
    @if (isUrgent(row) || isVip(row)) {
      <div class="flex flex-wrap items-center justify-start gap-1">
        @if (isVip(row)) {
          <span
            class="inline-flex w-max items-center gap-1 rounded-full bg-[#fff9e8] px-2 py-0.5 text-[11px] font-semibold text-[#ffa514] dark:bg-[#4b3817] dark:text-[#ffd37a]"
          >
            <app-icon-v2 name="gem" size="10" customClass="text-[#ffa514]"></app-icon-v2>
            VIP
          </span>
        }
      </div>
    }
  </div>
</ng-template>

<ng-template #lendeeShareTypeTemplate let-row>
  <span class="text-[14px] text-[#141437] dark:text-white">{{ getLendeeShareType(row) }}</span>
</ng-template>

<ng-template #lendeeStatusTemplate let-row>
  <span
    class="inline-flex rounded-full px-2.5 py-1 text-[12px] font-semibold"
    [ngClass]="{
      'bg-[#edfff3] text-[#15b268] dark:bg-[#173b31] dark:text-[#7ae5ac]': isLendeePaid(row),
      'bg-[#fff0f0] text-[#f05050] dark:bg-[#3f1d29] dark:text-[#ff9090]': !isLendeePaid(row) && getLendeeStatus(row) === 'Unpaid'
    }"
  >
    {{ getLendeeStatus(row) }}
  </span>
</ng-template>

<ng-template #lendeeContractDetailsTemplate let-row>
  <div class="space-y-1 text-[13px] whitespace-nowrap">
    <div class="flex flex-wrap items-center gap-1.5">
      <a class="font-semibold text-[#0c66e8] dark:text-[#6eb3ff]">{{ getLendeeContractCode(row) }}</a>
      @if (isUrgent(row)) {
        <span
          class="inline-flex w-max items-center gap-1 rounded-full bg-[#f4e5ff] px-2 py-0.5 text-[11px] font-medium text-[#ad46ff] dark:bg-purple-800 dark:text-white"
        >
          <app-icon-v2 name="zap" size="10" customClass="text-[#ad46ff] fill-current"></app-icon-v2>
          Urgent
        </span>
      }
    </div>
    <div class="text-[#7d7d93] dark:text-ink-muted">Contract Type: <span class="text-[#141437] dark:text-white">{{ getLendeeContractType(row) }}</span></div>
    <div class="grid transition-all duration-300 ease-in-out"
      [ngClass]="isLendeeRowExpanded(row) ? 'mt-1 grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'">
      <div class="overflow-hidden space-y-1 border-t border-dashed border-[#e5e7eb] pt-1 dark:border-surface-3">
        <div class="text-[#7d7d93] dark:text-ink-muted">Contract State: <span [ngClass]="getLendeeContractStateClass(row)">{{ getLendeeContractState(row) }}</span></div>
        <div class="text-[#7d7d93] dark:text-ink-muted">Financed Amount: <span class="text-[#141437] dark:text-white">{{ getLendeeFinancedAmount(row) | currency }}</span></div>
        <div class="text-[#7d7d93] dark:text-ink-muted">Term: <span class="text-[#141437] dark:text-white">{{ getLendeeTerm(row) }}</span></div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #lendeeSupporterDetailsTemplate let-row>
  <div class="space-y-1 text-[13px] whitespace-nowrap">
    <div class="text-[#7d7d93] dark:text-ink-muted">Requested Amount: <span class="text-[#141437] dark:text-white">{{ getLendeeRequestedAmount(row) | currency }}</span></div>
    <div class="text-[#7d7d93] dark:text-ink-muted">Duration (Months): <span class="text-[#141437] dark:text-white">{{ getLendeeDuration(row) }}</span></div>
    <div class="grid transition-all duration-300 ease-in-out"
      [ngClass]="isLendeeRowExpanded(row) ? 'mt-1 grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'">
      <div class="overflow-hidden space-y-1 border-t border-dashed border-[#e5e7eb] pt-1 dark:border-surface-3">
        <div class="text-[#7d7d93] dark:text-ink-muted">Supporter Investment: <span class="text-[#141437] dark:text-white">{{ getLendeeSupporterInvestment(row) | currency }}</span></div>
        <div class="text-[#7d7d93] dark:text-ink-muted">Supporter Return: <span class="text-[#141437] dark:text-white">{{ getLendeeSupporterReturn(row) | currency }}</span></div>
        <div class="text-[#7d7d93] dark:text-ink-muted">Recurring Amount: <span class="text-[#141437] dark:text-white">{{ getLendeeRecurringAmount(row) | currency }}</span></div>
        <div class="text-[#7d7d93] dark:text-ink-muted">Lendee Request ID: <span class="text-[#141437] dark:text-white">{{ getLendeeRequestId(row) }}</span></div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #lendeePaymentDetailsTemplate let-row>
  <div class="space-y-1 text-[13px] whitespace-nowrap">
    <div class="text-[#7d7d93] dark:text-ink-muted">Payment Received: <span class="text-[#141437] dark:text-white">{{ getLendeePaymentReceived(row) }}</span></div>
    <div class="text-[#7d7d93] dark:text-ink-muted">Paid to Supporter: <span class="text-[#141437] dark:text-white">{{ getLendeePaidToSupporter(row) }}</span></div>
    <div class="grid transition-all duration-300 ease-in-out"
      [ngClass]="isLendeeRowExpanded(row) ? 'mt-1 grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'">
      <div class="overflow-hidden space-y-1 border-t border-dashed border-[#e5e7eb] pt-1 dark:border-surface-3">
        <div class="text-[#7d7d93] dark:text-ink-muted">Paid to Business: <span class="text-[#141437] dark:text-white">{{ getLendeePaidToBusiness(row) }}</span></div>
        <div class="text-[#7d7d93] dark:text-ink-muted">Payments Remaining: <span class="text-[#141437] dark:text-white">{{ getLendeeRemainingPayments(row) }}</span></div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #lendeeBusinessInsightsTemplate let-row>
  <div class="space-y-1 text-[13px] whitespace-nowrap">
    <div class="text-[#7d7d93] dark:text-ink-muted">Total Contracts: <span class="text-[#141437] dark:text-white">{{ getLendeeTotalContracts(row) }}</span></div>
    <div class="text-[#7d7d93] dark:text-ink-muted">Active Contracts: <span class="text-[#141437] dark:text-white">{{ getLendeeActiveContracts(row) }}</span></div>
    <div class="grid transition-all duration-300 ease-in-out"
      [ngClass]="isLendeeRowExpanded(row) ? 'mt-1 grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'">
      <div class="overflow-hidden space-y-1 border-t border-dashed border-[#e5e7eb] pt-1 dark:border-surface-3">
        <div class="text-[#7d7d93] dark:text-ink-muted">Overdue Contracts: <span class="text-[#141437] dark:text-white">{{ getLendeeOverdueContracts(row) }}</span></div>
        <div class="text-[#7d7d93] dark:text-ink-muted">Completed Contracts: <span class="text-[#141437] dark:text-white">{{ getLendeeCompletedContracts(row) }}</span></div>
        <div class="text-[#7d7d93] dark:text-ink-muted">Cancelled Contracts: <span class="text-[#141437] dark:text-white">{{ getLendeeCancelledContracts(row) }}</span></div>
        <div class="text-[#7d7d93] dark:text-ink-muted">Last Contract Date: <span class="text-[#141437] dark:text-white">{{ getLendeeLastContractDate(row) }}</span></div>
        <div class="text-[#7d7d93] dark:text-ink-muted">Industry Name: <span class="text-[#141437] dark:text-white">{{ getLendeeIndustryName(row) }}</span></div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #lendeeSupporterInsightsTemplate let-row>
  <div class="space-y-1 text-[13px] whitespace-nowrap">
    <div class="text-[#7d7d93] dark:text-ink-muted">Contracts Funded: <span class="text-[#141437] dark:text-white">{{ getLendeeContractsFunded(row) }}</span></div>
    <div class="text-[#7d7d93] dark:text-ink-muted">Funded Value: <span class="text-[#141437] dark:text-white">{{ getLendeeFundedValue(row) | currency }}</span></div>
  </div>
</ng-template>

<ng-template #lendeeBankAddedTemplate let-row>
  <span class="text-[14px] font-medium" [ngClass]="{
    'text-[#15b268]': getLendeeBankAdded(row) === 'Yes',
    'text-[#f05050]': getLendeeBankAdded(row) === 'No'
  }">
    {{ getLendeeBankAdded(row) }}
  </span>
</ng-template>

<ng-template #lendeeActionTemplate let-row>
  <div class="flex items-center justify-start gap-2" data-row-action-menu-root (click)="$event.stopPropagation()">
    <button
      type="button"
      class="inline-flex h-8 items-center justify-center rounded-[8px] bg-[#AD46FF] px-4 text-[13px] font-medium text-white transition hover:bg-[#962ef7] disabled:cursor-not-allowed disabled:opacity-60"
      [disabled]="paying() || isLendeePaid(row)"
      (click)="paySingle(row)"
    >
      Pay
    </button>
    <button
      type="button"
      class="inline-flex h-8 items-center justify-center rounded-[8px] border border-[#dfe5ed] bg-white px-3 text-[13px] font-medium text-[#38385b] transition hover:bg-[#f8f8f8] dark:border-surface-3 dark:bg-surface-1 dark:text-ink-soft dark:hover:bg-surface-3"
      (click)="toggleLendeeDetails(row)"
    >
      @if (isLendeeRowExpanded(row)) {
        Hide Details
      } @else {
        Show Details
      }
    </button>
    @if (getDisplayRowMenuOptions(row).length) {
      <div class="relative z-[1]">
        <button
          type="button"
          class="flex h-8 w-8 items-center justify-center rounded-[8px] border border-[#dfe5ed] bg-white text-[#7d7d93] hover:bg-[#f8f8f8] disabled:cursor-not-allowed disabled:opacity-60 dark:border-surface-3 dark:bg-surface-1 dark:text-ink-muted dark:hover:bg-surface-3"
          [disabled]="isRowActionsDisabled()"
          [attr.aria-expanded]="isActionMenuOpen(row)"
          aria-haspopup="true"
          (click)="toggleActionMenu(row, $event)"
        >
          <app-icon-v2 name="ellipsis-vertical" size="16"></app-icon-v2>
        </button>
      </div>
    }
  </div>
</ng-template>

<ng-template #actionTemplate let-row>
  <div class="flex items-center justify-start gap-2" data-row-action-menu-root (click)="$event.stopPropagation()">
    <button
      type="button"
      class="inline-flex h-8 items-center justify-center rounded-[8px] bg-[#AD46FF] px-4 text-[13px] font-medium text-white transition hover:bg-[#962ef7] disabled:cursor-not-allowed disabled:opacity-60"
      [disabled]="isRowActionsDisabled() || !canPayRow(row)"
      (click)="paySingle(row)"
    >
      Pay
    </button>
    @if (getDisplayRowMenuOptions(row).length) {
      <div class="relative z-[1]">
        <button
          type="button"
          class="flex h-8 w-8 items-center justify-center rounded-[8px] border border-[#dfe5ed] bg-white text-[#7d7d93] hover:bg-[#f8f8f8] disabled:cursor-not-allowed disabled:opacity-60 dark:border-surface-3 dark:bg-surface-1 dark:text-ink-muted dark:hover:bg-surface-3"
          [disabled]="isRowActionsDisabled()"
          [attr.aria-expanded]="isActionMenuOpen(row)"
          aria-haspopup="true"
          (click)="toggleActionMenu(row, $event)"
        >
          <app-icon-v2 name="ellipsis-vertical" size="16"></app-icon-v2>
        </button>
      </div>
    }
  </div>
</ng-template>

@if (openActionMenuRow() && actionMenuPosition(); as menuPos) {
  <div class="fixed inset-0 z-[150]" (click)="closeActionMenu()" aria-hidden="true"></div>
  <div
    #actionMenuPanel
    data-row-action-menu-root
    class="fixed z-[200] w-[220px] overflow-hidden rounded-[10px] border border-[#e5e7eb] bg-white py-1 shadow-xl dark:border-surface-3 dark:bg-surface-1"
    [style.top.px]="menuPos.top"
    [style.left.px]="menuPos.left"
    (click)="$event.stopPropagation()"
  >
    @for (option of getDisplayRowMenuOptions(openActionMenuRow()!); track option.value) {
      <button
        type="button"
        class="flex w-full items-center gap-2 px-3 py-2 text-left text-[13px] text-[#38385b] transition hover:bg-[#f2f5f8] dark:text-ink-soft dark:hover:bg-surface-3"
        (click)="onRowMenuOptionSelect(option.value, openActionMenuRow()!, $event)"
      >
        @if (option.icon) {
          <app-icon-v2
            [name]="option.icon"
            size="16"
            [customClass]="option.iconClass || 'text-[#7d7d93] dark:text-ink-muted'"
          ></app-icon-v2>
        }
        <span>{{ option.label }}</span>
      </button>
    }
  </div>
}

<div
  class="bulk-selection-footer fixed bottom-0 right-0 z-[100] border-t border-[#e5e7eb] bg-white p-4 shadow-[0_-4px_10px_0_rgba(0,0,0,0.05)] transition-[transform,opacity] duration-300 ease-out will-change-transform dark:border-surface-3 dark:bg-surface-1"
  [class.bulk-selection-footer--visible]="selectedIds().length > 0"
  [attr.aria-hidden]="selectedIds().length === 0"
  [style.left]="'var(--sidebar-width, 0px)'"
>
  <div class="mx-auto flex flex-col items-start gap-4 px-4 xl:flex-row xl:items-center xl:justify-between xl:px-8">
    <div class="flex flex-col">
      <div class="text-[24px] font-bold leading-tight text-[#141437] tabular-nums dark:text-white">
        {{ totalSelectedAmount() | currency }}
      </div>
      <div class="mt-1 flex flex-wrap items-center gap-4 text-[13px] text-[#7d7d93] dark:text-ink-muted">
        <div class="flex items-center gap-1.5">
          <app-icon-v2 name="building" size="14"></app-icon-v2>
          Paying to
          <span class="font-semibold text-[#141437] dark:text-white">{{ selectedBusinessesCount() }}</span>
          businesses
        </div>
        <span class="text-[#e5e7eb] dark:text-surface-3">|</span>
        <div class="flex items-center gap-1.5">
          <app-icon-v2 name="receipt" size="14"></app-icon-v2>
          <span class="font-semibold text-[#141437] dark:text-white">{{ selectedPayableCount() }}</span>
          Payments
        </div>
        @if (selectedUrgentCount() > 0) {
          <div
            class="flex items-center gap-1.5 rounded-full bg-[#f4e5ff] px-2.5 py-0.5 text-[#ad46ff] dark:bg-purple-800/20"
          >
            <app-icon-v2 name="zap" size="14" strokeWidth="2.5"></app-icon-v2>
            <span class="font-semibold">
              {{ selectedUrgentCount() }} urgent payments - {{ selectedUrgentAmount() | currency }}
            </span>
          </div>
        }
      </div>
    </div>

    <div class="flex items-center gap-3">
      @if (moreOptions().length) {
        <app-dropdown
          [options]="moreOptions()"
          selectionMode="single"
          selectionStyle="none"
          [clearable]="false"
          [disabled]="isBulkMoreDisabled()"
          variant="outline"
          size="md"
          position="top-left"
          placeholder="More"
          [fullWidth]="false"
          customWidth="180px"
          menuTitle="More Options"
          (selectionChange)="onMoreOptionClick($event)"
        >
          <button
            appDropdownTrigger
            type="button"
            class="inline-flex h-11 items-center gap-2 rounded-[10px] border border-[#AD46FF] bg-white px-5 text-[14px] font-medium text-[#AD46FF] transition hover:border-[#962ef7] hover:bg-[#faf5ff] hover:text-[#962ef7] dark:border-purple-500 dark:bg-surface-1 dark:text-purple-400 dark:hover:border-line-strong dark:hover:bg-surface-3 dark:hover:text-white"
          >
            More
          </button>
        </app-dropdown>
      }

      <button
        type="button"
        class="inline-flex h-11 items-center rounded-[10px] bg-[#AD46FF] px-6 text-[14px] font-medium text-white transition hover:bg-[#962ef7] disabled:cursor-not-allowed disabled:opacity-60"
        [disabled]="paying() || adminLoading() || !selectedPayableCount()"
        (click)="paySelected()"
      >
        {{ paying() ? 'Processing...' : 'Make Payments' }}
      </button>
    </div>
  </div>
</div>
